import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { RouteTitleMap, TitleEntry } from '@/routing/document-title/types';
import { useTitleParams } from './TitleContext';

const findRouteTitle = (titleMap: RouteTitleMap, pathname: string): TitleEntry | undefined => {
  const entries = Object.entries(titleMap).sort(([a], [b]) => b.split('/').length - a.split('/').length);

  const entry = entries.find(([pattern]) => matchPath(pattern, pathname));
  return entry?.[1];
};

type DocumentTitleProps = {
  defaultTitle: string;
  config?: RouteTitleMap;
};

export const DocumentTitle = ({ defaultTitle, config = {} }: DocumentTitleProps) => {
  const { pathname } = useLocation();
  const { params } = useTitleParams();

  useEffect(() => {
    const entry = findRouteTitle(config, pathname);

    if (!entry) {
      document.title = defaultTitle;
    } else {
      document.title = typeof entry === 'function' ? entry(params) : entry;
    }
  }, [pathname, params, config, defaultTitle]);

  return null;
};
